import React, { useState } from 'react';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';
import { spring, AnimatedSwitch } from 'react-router-transition';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import { Header, Menu } from 'semantic-ui-react';
import Account from './Account';
import Billing from './Billing';
import Error from '../../components/Error/Error';
import { useTranslation } from 'react-i18next';
import '../../assets/fonts/vazir.css';
import './AccountSetting.css';

// we need to map the `scale` prop we define below
// to the transform style property
const mapStyles = styles => {
  return {
    opacity: styles.opacity,
    transform: `scale(${styles.scale})`,
  };
};

// wrap the `spring` helper to use a bouncy config
const bounce = val => {
  return spring(val, {
    stiffness: 330,
    damping: 22,
  });
};

// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    scale: 1.2,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: bounce(0),
    scale: bounce(0.8),
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: bounce(1),
    scale: bounce(1),
  },
};

const AccountSettingLayout = () => {
  const { t } = useTranslation();
  const [activeItem, setActiveItem] = useState('account');
  const history = useHistory();
  const { path, url } = useRouteMatch();

  const handleItemClick = (e, { name, link }) => {
    setActiveItem(name);
    history.push(`${url}${link}`);
  };

  return (
    <div className="accountSetting">
      <Header as="h3" style={{ fontSize: '2em' }} content={t('userAccountSettings')} />
      <div className="tabMenuBox">
        <Menu.Item
          className={`tabMenu ${activeItem == 'account' && 'active'}`}
          name="account"
          link=""
          onClick={handleItemClick}
          content={t('userAccount')}
        />
        {/* <Menu.Item
          className={`tabMenu ${activeItem == 'billing' && 'active'}`}
          name="billing"
          link="/billing"
          onClick={handleItemClick}
          content={t('billing')}
        /> */}
      </div>
      <div className="settingForms">
        <AnimatedSwitch
          atEnter={bounceTransition.atEnter}
          atLeave={bounceTransition.atLeave}
          atActive={bounceTransition.atActive}
          mapStyles={mapStyles}
          className="switch-wrapper"
        >
          <PrivateRoute path={path} exact component={Account} />
          <PrivateRoute path={`${path}/billing`} exact component={Billing} />
          <Route path="*" render={() => <Error error={'404'} redirectTo={'support'} />} />
        </AnimatedSwitch>
      </div>
    </div>
  );
};

export default AccountSettingLayout;
